/**
 * Validation translations
 * Form validation messages
 */

import { LANGUAGES } from '../config';

export const validationTranslations = {
  [LANGUAGES.EN]: {
    required: 'This field is required',
    email: 'Please enter a valid email address',
    password: 'Password must be at least 6 characters',
    passwordMismatch: 'Passwords do not match',
    invalidCredentials: 'Invalid email or password',
    minLength: 'Minimum {min} characters required',
    maxLength: 'Maximum {max} characters allowed',
    invalidFormat: 'Invalid format'
  },
  [LANGUAGES.FR]: {
    required: 'Ce champ est requis',
    email: 'Veuillez saisir une adresse email valide',
    password: 'Le mot de passe doit comporter au moins 6 caractères',
    passwordMismatch: 'Les mots de passe ne correspondent pas',
    invalidCredentials: 'Email ou mot de passe invalide',
    minLength: 'Minimum {min} caractères requis',
    maxLength: 'Maximum {max} caractères autorisés',
    invalidFormat: 'Format invalide'
  }
};